module.exports = __webpack_public_path__ + "img/W-S25.c09f2030.jpg";